module.exports = __webpack_public_path__ + "static/img/service-book@2x.0d59dfdc.png";